import React, { Fragment } from 'react'
import Table from 'UI/Table'
import BooleanIcon from 'UI/BooleanIcon'
import RAGIcon from 'FoundationalComponents/RAGIcon'
import { every, each, map, uniq, find, some } from 'lodash'

const AccessAssetsStatus = ({ data }) => {
  const providers = uniq(map(data, 'provider'))
  const summaryColumns = [
    { Header: 'Provider', accessor: 'provider' },
    { Header: 'Imported Count', accessor: 'importedToday', Cell: row => `${row.value}/${row.original.totalImports}` },
    { Header: 'Imported Properly', accessor: 'importedToday', Cell: row => (
      <BooleanIcon booleanValue={row.value === row.original.totalImports} size='big' />
    )}
  ]

  const columns = [
    { Header: 'Site', accessor: 'site_id', width: 150 },
    {
      Header: 'Provider', accessor: 'provider', width: 200, filterable: true,
      filterMethod: (filter, row) => {
        if (filter.value === 'all') { return true }

        return row[filter.id] === filter.value
      },
      Filter: ({ filter, onChange }) => (
        <select onChange={event => onChange(event.target.value)} style={{ width: "100%" }} value={filter ? filter.value : "all"}>
          <option value="all">Show All</option>
          {map(providers, provider => <option value={provider}>{provider}</option>)}
        </select>
    )},
    { Header: 'Name', accessor: 'name', filterable: true, },
    {
      Header: 'Imported Today?', accessor: 'importDetails',
      sortMethod: (a, b) => (every(a, importDetail => importDetail.importedToday) ? 1 : -1),
      Cell: ({ value }) => {
        let color = 'red'
        if (every(value, importDetail => importDetail.importedToday)) {
          color = 'green'
        } else if (some(value, importDetail => importDetail.importedToday)) {
          color = 'amber'
        }

        return <RAGIcon {...{ color, size: 'big' }} />
      }},
  ]
  const subRowColumns = [
    { Header: 'Asset Type', accessor: 'humanizedAssetType' },
    {
      Header: 'Imported Today?', accessor: 'importedToday', Cell: ({ value }) => (
        <BooleanIcon booleanValue={value} />
      )
    },
    { Header: 'Last Imported At', accessor: 'lastImportDate' },
  ]

  const summaryData = map(providers, provider => ({ provider, importedToday: 0, totalImports: 0 }))
  each(data, asset => {
    const providerData = find(summaryData, ['provider', asset.provider])
    providerData['totalImports'] = providerData['totalImports'] + 1

    if (every(asset.importDetails, importDetail => importDetail.importedToday)){
      providerData['importedToday'] = providerData['importedToday'] + 1
    }
  })

  return (
    <div className='row'>
      <div className="col col-3">
        <Table {...{ columns: summaryColumns, data: summaryData, tableProps: { showPagination: false } }} />
      </div>

      <div className="col col-9">
        <Table {...{ columns, data, tableProps: {
          SubComponent: (row) => (
            <Table
              data={row.original.importDetails}
              columns={subRowColumns}
              tableProps={{
                pageSize: row.original.importDetails.length,
                showPagination: false
              }}
            />
          )
        }}} />
      </div>
    </div>
  )
}

export default AccessAssetsStatus
